import React from 'react'
import { Base, Button, HTMLText, Icon } from '@crossfit/ui'
import classNames from 'classnames'
import style from './style.module.scss'
import { useSelector } from 'react-redux'
import { getBanner, getMyAffiliates } from 'store/selectors'
import { trackEvent } from 'services/segment'

export default function NotificationBanner({ className }) {
  const { selectedAffiliate } = useSelector(getMyAffiliates)
  const bannerState = useSelector(getBanner)
  const bannerTypeToIcon = () => {
    switch (bannerState.bannerType) {
      case 'info':
        return 'info'
      case 'warning':
        return 'alert'
      default:
        return 'alert'
    }
  }
  const displayCTAButton: boolean =
    bannerState.buttonText != null &&
    bannerState.buttonText != '' &&
    bannerState.buttonUrl != null &&
    bannerState.buttonUrl != ''

  return (
    <Base
      className={classNames(style.wrapper, className, {
        [style.info]: bannerState.bannerType === 'info',
        [style.warning]: bannerState.bannerType === 'warning',
      })}
    >
      <div className={style.bannerTopRow}>
        <Icon
          name={bannerTypeToIcon()}
          height={16}
          width={16}
          className={classNames(style.icon, {
            [style.info]: bannerState.bannerType === 'info',
            [style.warning]: bannerState.bannerType === 'warning',
          })}
        />
        <HTMLText className={style.bodyText}>
          {bannerState.bannerMessage}
        </HTMLText>
      </div>

      {displayCTAButton && (
        <Button
          className={style.button}
          variant='secondary'
          onClick={() => {
            trackEvent({
              component: 'atk-banner',
              event: 'Pop-up Banner Clicked',
              text: bannerState.buttonText,
              linkUrl: bannerState.buttonUrl,
              affiliateId: selectedAffiliate?.affiliateId,
              userRole:
                selectedAffiliate?.roles?.length > 0
                  ? selectedAffiliate?.roles[0]
                  : null,
              groupId: selectedAffiliate?.groupId,
              bannerName: bannerState?.bannerName,
              bannerCategory: 'Product Marketing',
              bannerLocation: 'top',
            })
            location.href = bannerState.buttonUrl
          }}
        >
          {bannerState.buttonText}
        </Button>
      )}
    </Base>
  )
}
